import type { Hook } from '../types';

export function beforeRenderStandardChart(...args: Parameters<Hook['beforeRenderStandardChart']>) {
  const [, { option }] = args;

  // * 同一个 grid 内多 y 轴名称位置问题，将多余的轴隐藏
  const girdMap = {
    0: {
      countLeftYAxis: 0,
      countRightYAxis: 0
    }
  };

  option?.yAxis?.forEach((axis, index) => {
    const gridIndex = axis.gridIndex || 0;
    let counter = girdMap[gridIndex];
    if (!counter) {
      counter = girdMap[gridIndex] = {
        countLeftYAxis: 0,
        countRightYAxis: 0
      };
    }

    const isRight = axis?.position === 'right';

    if (isRight || (counter.countLeftYAxis > 0 && axis?.position !== 'left')) {
      if (counter.countRightYAxis > 0) {
        // eslint-disable-next-line no-param-reassign
        axis.show = false;
      }

      counter.countRightYAxis += 1;
    } else {
      if (counter.countLeftYAxis > 0) {
        // eslint-disable-next-line no-param-reassign
        axis.show = false;
      }

      counter.countLeftYAxis += 1;
    }
  });
}

export default beforeRenderStandardChart;
